const keyboardDatePickerModalFilterService = {
  from: 'De',
  to: 'Até'
};

export default keyboardDatePickerModalFilterService;
